import { render, staticRenderFns } from "./ProjectBiddingClosed.vue?vue&type=template&id=3e0438d2&scoped=true&"
import script from "./ProjectBiddingClosed.vue?vue&type=script&lang=js&"
export * from "./ProjectBiddingClosed.vue?vue&type=script&lang=js&"
import style0 from "./ProjectBiddingClosed.vue?vue&type=style&index=0&id=3e0438d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0438d2",
  null
  
)

export default component.exports